module.exports = __webpack_public_path__ + "img/b257c38e357a64367c660c77ffb5af37.png";